import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

import VueToast from "vue-toast-notification";
import "vue-toast-notification/dist/theme-default.css";
import messagePlugin from "@/utils/message.plugin";
import VueTheMask from "vue-the-mask";
import vSelect from "vue-select";
import VueInputAutoWidth from "vue-input-autowidth";
import onlyInt from "vue-input-only-number";
// import Fragment from "vue-fragment";
import ProgressBar from "vuejs-progress-bar";
import Pagination from "vue-pagination-2";

import firebaseConfig from "../firebaseConfig";
import firebase from "firebase/app";
import "firebase/auth";
import "firebase/database";
import "firebase/storage";

firebase.initializeApp(firebaseConfig);

let app;

Vue.config.productionTip = false;

firebase.auth().onAuthStateChanged(() => {
  if (!app) {
    app = new Vue({
      router,
      store,
      render: h => h(App)
    }).$mount("#app");

    Vue.use(VueToast);
    Vue.use(messagePlugin);
    Vue.use(VueTheMask);
    Vue.use(VueInputAutoWidth);
    Vue.use(onlyInt);
    // Vue.use(Fragment.Plugin);
    Vue.use(ProgressBar);

    vSelect.props.components.default = () => ({
      OpenIndicator: {
        render: createElement =>
          createElement("span", {
            class: "icon icon-down"
          })
      }
    });
    Vue.component("v-select", vSelect);
    Vue.component("pagination", Pagination);
  }
});
